import { TFunction } from 'i18next';
import * as Yup from 'yup';

export const validationSchema = (t: TFunction) =>
  Yup.object().shape({
    breakStartAt: Yup.date().nullable().required(t('valid_err_required')),
    breakEndAt: Yup.date()
      .nullable()
      .required(t('valid_err_required'))
      .test(
        'is-after-breakstart',
        t('Break end time must be after break start time'),
        function (value) {
          const { breakStartAt } = this.parent;

          if (!breakStartAt || !value) return true;

          return value >= breakStartAt;
        }
      ),
    note: Yup.string()
      .required(t('valid_err_required'))
      .trim()
      .max(255, t('CannotExceedCharacters', { char: 255 })),
  });

export type BreakingTimeValidationSchemaType = ReturnType<
  typeof validationSchema
>;
